import React, { useState, useEffect } from 'react';
import { Input } from 'components/shared/FormComponent';
import { Empty, Progress, Table, Tooltip } from 'components/shared/AntComponent';
import SearchIcon from 'assets/img/search.svg';
import { CheckCircleOutlined, DeleteFilled, RiseOutlined, WarningOutlined, PauseOutlined, PlayCircleOutlined, CloseOutlined } from 'components/shared/AntIcons';
import { Button } from 'components/shared/ButtonComponent';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/table.scss';
import 'assets/styles/dashboard.scss';
import ApexChart from "components/shared/ComponentLoader";
import { ResetIcon } from 'assets/img/custom-icons';
const generateLast24HourLabels = (): string[] => {
    const labels: string[] = [];
    const now = new Date();

    for (let i = 23; i >= 0; i--) {
        const time = new Date(now);
        time.setHours(now.getHours() - i);
        time.setMinutes(0, 0, 0);
        labels.push(
            time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })
        ); // "08:00", "09:00" ...
    }

    return labels;
};

const JobHealthMonitor: React.FC = () => {
    const loading = false;
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortOrder, setSortOrder] = useState('');
    const [sortField, setSortField] = useState('desc');
    const totalPage = 0;
    const customLocale = {
        emptyText: <Empty className="p-2" description="No job available" />,
    };
    const statItems = [
        { id: 1, title: "Total Jobs", count: '244', icon: <CheckCircleOutlined className='text-success' />, color: 'text-success', bgcolor: '#10b77f1a', },
        { id: 2, title: "Processing Jobs", count: '34', icon: <RiseOutlined className='text-blue' />, color: 'text-blue', bgcolor: '#1a6ef41a', },
        { id: 3, title: "Error Jobs", count: '44', icon: <WarningOutlined className="text-danger" />, color: 'text-danger', bgcolor: '#ef43431a', },
        { id: 4, title: "Idle Jobs", count: '33', icon: <PauseOutlined className="text-warning" />, color: 'text-warning', bgcolor: '#f59f0a1a', },
        { id: 5, title: "Completed Jobs", count: '133', icon: <PlayCircleOutlined className="text-gray" />, color: 'text-gray', bgcolor: '#f1f5f9', }
    ];
    const data = [
        { id: 1, job_number: '987987', start_time: '10:00AM', end_time: '10:20AM', duration: '20 mins', status: 'processing',progress:'50' }
    ];
    const columns: any['columns'] = [
        {
            title: 'S.no',
            dataIndex: 'sno',
            key: 'sno',
            render: (id: number, record: any, index: number) => {
                if (pageIndex === 1) {
                    return index + 1;
                } else {
                    return (pageIndex - 1) * pageSize + (index + 1);
                }
            },
        },
        {
            title: 'Job #',
            dataIndex: 'job_number',
            key: 'job_number',
            sorter: true,
            // render: (_: any, record: any) => (
            //     <div>{record?.encrypt_templateNumber || "--"}</div>
            // )
        },
        {
            title: 'Job Start Time',
            dataIndex: 'start_time',
            key: 'start_time',


        },
        {
            title: 'Job End Time',
            dataIndex: 'end_time',
            key: 'end_time',
            // render: (id: any, record: any) => {
            //     return record.template_category || "--";
            // },
        },
        {
            title: 'Duration',
            dataIndex: 'duration',
            key: 'duration',

        },
        {
            title:'Progress',
            dataIndex:'progress',
            key:'progress',
            render:(_:any,record:any)=>{
                return(
                    <div><Progress percent={record?.progress} status="active" /></div>
                )
            }
        },
        // {
        //     title: 'Last Run',
        //     dataIndex: 'last_run',
        //     key: 'last_run',

        // },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'action',
            align: 'center',
            render: (status: any) => {
                const val = status?.toLowerCase();
                if (val === 'processing') {
                    return <div className='status-section mx-auto'><Button className="warning-btn fw-bold text-center mx-auto px-2">{status}</Button></div>;
                } else {
                    return <div className='status-section mx-auto'><Button className="danger-btn text-center mx-auto px-2 text-capitalize">{val}</Button></div>;
                }
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            className: 'action-column',
            // align:'center',
            render: (_id: any, record: any) => {
                return (
                    <div
                        className="p-2 text-center d-flex justify-content-center"
                        onClick={(event) => {
                            event.stopPropagation();
                        }}
                    >
                        <Tooltip title="Restart Job" className="mt-0">
                            <span><ResetIcon /></span>

                        </Tooltip>
                        <div className="ms-2">
                            <Tooltip title="Cancel Job" className="mt-0">
                                <span> <CloseOutlined className="text-danger" /></span>
                            </Tooltip>
                        </div>
                        {/* {(userRole === 'researcher' || userProfileInfo?.data?.sub_roll === 'researcher') ? (
                                    <DeleteFilled className="text-secondary" />
                                ) : (
                                    <Popconfirm
                                        placement="topLeft"
                                        title="Are you sure to delete this patient?"
                                        description="Delete the patient"
                                        onConfirm={() => {
                                            confirmDelete('False', record.id);
                                            setShowSuccessmsg1(true);
                                            setShowErrormsg1(true);
                                        }}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Tooltip title="Delete" className="mt-0">
                                            <DeleteFilled className="fs-18 text-danger" />
                                        </Tooltip>
                                    </Popconfirm>
                                )} */}
                    </div>
                );
            },
        },
    ];
    const handleOpenDelModal = (val: any) => {

    }
    const tableChange = (pagination: any, ...sorted: any) => {
        let sort = '',
            sortfield = '';
        if (sorted[1].order === 'ascend') {
            sort = 'asc';
        } else if (sorted[1].order === 'descend') {
            sort = 'desc';
        } else sort = '';
        setPageIndex(pagination.current);
        if (sort == '') {
            sortfield = '';
            setSortField('');
        } else {
            setSortField(sorted[1].field);
            sortfield = sorted[1].field;
        }
        setSortOrder(sort);
        setPageSize(pagination.pageSize);
        // getAccount(searchTableVal, pagination.current, pagination.pageSize, sortfield, sort, isStatus);
    };

    const options: any = {
        chart: {
            type: 'line',
            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false // Disable zooming
            },
        },
        // title: {
        //     text: 'Job Activity Trend',
        //     align: 'left',
        //     floating: false,
        //     offsetX: 10,
        //     offsetY: 25,
        //     style: {
        //         fontWeight: 'bold',
        //         // FontFamily: 'Lato',
        //     },
        // },
        legend: {
            show: true,
            position: 'top',
            // t: 'right',
            horizontalAlign: 'right',
            fontFamily: 'Lato',
            // markers: {
            //     width: 15,
            //     height: 3,
            // },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: 'smooth',
            width: 2,
        },
        colors: ['#10b77f', '#1a6ef4', '#ef4343'],
        xaxis: {
            // type: 'date',
            format: "HH:mm",
            tickAmount: 5,
            categories: generateLast24HourLabels() || [],
        },
        tooltip: {
            x: {
                format: 'MM/dd/yy ',
                // max: 4,
            },
        },
    };
    const series = [
        {
            name: 'Completed Jobs',
            type: 'line',
            data: [20, 0, 0, 0, 5, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
            name: 'Processing Jobs',
            type: 'area',
            data: [56, 0, 35, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 45],
        },
        {
            name: 'Error Jobs',
            type: 'line',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 67, 5, 44, 6, 7, 74],
        },
    ];
    const serviceReqOptions: any = {
        labels: ['Yet to start (2)', 'Processing (3)', 'Completed (3)', 'Error (2)', 'Idle (2)'],
        colors: ['#65758b', '#1a6ef4', '#10b77f', '#ef4343', '#f59f0a'],
        chart: {
            type: 'pie',
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        // title: {
        //     text: 'New Request Vs Released Request',
        //     align: 'left',
        //     margin: 10,
        //     floating: false,
        //     style: {
        //         fontSize: '14px',
        //         fontWeight: 'bold',
        //         // FontFamily: 'Lato',
        //     },
        // },
        legend: {
            show: true,
            fontSize: '10px',
            position: 'bottom',
            // align: 'right',
            horizontalAlign: 'center',
            // markers: {
            //     width: 8,
            //     height: 8,
            //     radius: 5,
            //     offsetX: -5,
            // },
        },
        stroke: {
            width: 3,
        },
        plotOptions: {
            pie: {
                expandOnClick: false,
                donut: {
                    labels: {
                        show: false,

                        total: {
                            show: false,
                        },
                    },
                },
            },
        },
    };
    const serviceReqSeries = [2, 3, 3, 2, 2];
    return (
        <div className='p-3 dashboard-container'>
            <div className="d-flex grid-title-card">
                <h5 className="my-auto ">Job Health Monitor</h5>
            </div>
            <div className='my-3'>
                <div className='row mx-0'>
                    <div className="col px-0">
                        <div className="row mx-0 mb-1 dash-cards dash-cards1">
                            {statItems?.map((item: any) => {
                                return (
                                    <div className={`col ps-0 dashboard-cards ${item.id==5?'pe-0':''}`} key={item.id}>
                                        <div className="p-2 w-100 rounded d-flex bg-white border shadow-sm">
                                            <div className={`${item.color} icon-cont col-auto px-2 my-2 py-2 rounded-circle ms-3`} style={{ backgroundColor: item.bgcolor }}>
                                                {item.icon}
                                            </div>
                                            <div className="m-auto">
                                                <h4 className="text-dark mb-1">{item.count}</h4>
                                                <span className="text-muted w-75 fs-15 fw-bold">{item.title}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                </div>
                <div className="row mx-0 mt-3">
                    <div className='col-md-8 bg-white p-3'>
                        <h6>Job Activity Trend</h6>
                        <p className='text-muted'>Completed, errors and processing over 24 hours</p>
                        <ApexChart options={options} series={series} type="area" width="100%" height="280vh" />
                    </div>
                    <div className='col ms-2 bg-white p-3 d-flex align-items-center justify-content-center'>
                        <ApexChart options={serviceReqOptions} series={serviceReqSeries} type="donut" height="280vh" width="100%" />
                    </div>
                </div>
                <div className='my-3 row mx-0'>
                    <div className='col px-0'>
                        <Table
                            rowKey="id"
                            className="pointer border"
                            columns={columns}
                            dataSource={loading ? [] : data}
                            loading={loading}
                            onChange={tableChange}
                            scroll={{ x: 'calc(230px + 50%)' }}
                            locale={customLocale}
                            pagination={{
                                current: pageIndex,
                                pageSize: pageSize,
                                total: totalPage,
                            }} />
                    </div>


                </div>
            </div>
        </div>
    )
}

export default JobHealthMonitor;